module.exports = __webpack_public_path__ + "static/media/cross_purple.d672f9e2.svg";